@let $items = items() | async;
@if (!$items) {
  <spinner class="app-fillf"/>
} @else if ($items.count > 0) {
  @if (paged() && $items.pages > 1) {
    <!-- TODO -->
  }

  @for ($item of $items.items; track $item.id) {
    <div class="rounded bordered">
      <app-entity-card [entity]="$item"/>
    </div>
  }

} @else {
  <ng-content/>
}
